import { useState, useRef, useEffect } from 'react';
import Input from '../../Components/Input/Input';
import Button from '../../Components/Buttons'
import Loader from '../../Components/Lottie';
import loader from '../../Assets/json/spinner.json';


const SignupForm = ({ registerUserHandler, authState }) => {
  const firstInput = useRef(null);

  useEffect(() => {
    firstInput.current.focus();
  }, []);

  const [formInput, setFormInput] = useState({
    name: "",
    email: "",
    password: "",
  });

  const inputChangeHandler = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const registerUser = (e) => {
    e.preventDefault();
    registerUserHandler(formInput);
  };

  return (
    <form onSubmit={registerUser}>
      <Input
        required
        ref={firstInput}
        value={formInput?.name}
        onChange={inputChangeHandler}
        name="name"
        label="Name*"
      />

      <div className="mt-4 md:mt-6">
        <Input
          type="email"
          required
          value={formInput.email}
          onChange={inputChangeHandler}
          name="email"
          label="Email*"
          placeholder="example@gmail.com"
        />
      </div>
      <div className="my-4 md:my-6">
        <Input
          type="password"
          required
          value={formInput.password}
          onChange={inputChangeHandler}
          name="password"
          label="Password*"
        />
      </div>
      <div>
        <Button disabled={authState?.registering || authState?.registeringWithGoogle} type="submit">
          <span className="text-center w-full inline-block py-2 md:py-3 font-ubuntu text-xs leading-2">
            {!authState?.registering && <span>SIGNUP</span>}

            {authState?.registering && (
              <span className="w-full flex items-center justify-center">
                <span className="w-6 h-6 block">
                  <Loader loader={loader} />
                </span>
              </span>
            )}
          </span>
        </Button>
      </div>
    </form>
  );
};

export default SignupForm;